import Axios from "../config/axios-v1-config";
import i18n from "../i18n/index.js";
import { apiErrorMessage, apiErrorStatus } from "../utils/apiErrorMessage";

/**
 * Suscripciones de webhooks del OPERADOR.
 *
 * El alcance no viaja en el cuerpo: el backend lo impone desde el JWT. Un
 * operador sólo puede crear, ver y tocar las suyas, mande lo que mande. Por eso
 * acá no hay `scope` ni `scopeId` — no serviría de nada enviarlos.
 *
 * Mismo criterio que el resto de esta capa: se devuelve `{ error }` en vez de
 * lanzar, para que la sección decida cómo mostrarlo.
 */

const RUTA = "integrations/webhooks/subscriptions";

// El consumidor hace `toast.error(String(r.error))`, así que `error` tiene que
// ser SIEMPRE texto: el helper descarta HTML de proxy, frases genéricas y
// cuerpos sin mensaje, y une los arrays del ValidationPipe de Nest con " · ".
// Los fallbacks se traducen al fallar (no al cargar el módulo) para respetar
// el idioma activo en ese momento.
// AdminOnlyGuard responde 403 con cuerpo {message:'Forbidden'}, que el helper
// descarta por genérico: sin el texto propio el usuario no sabría que es un
// tema de rol.
const falla = (err) => ({
  error: apiErrorMessage(
    err,
    apiErrorStatus(err) === 403
      ? i18n.t("No tienes permisos para administrar webhooks")
      : i18n.t("No se pudo completar la operación"),
  ),
});

export const getWebhookSubscriptions = async () => {
  try {
    const { data } = await Axios.get(RUTA);
    return Array.isArray(data) ? data : (data?.data ?? []);
  } catch (err) {
    return falla(err);
  }
};

/**
 * Crea una suscripción.
 *
 * OJO: la respuesta trae `secret` en claro y es la ÚNICA vez que el servidor lo
 * devuelve. Si la vista no lo muestra en ese momento, hay que rotarlo.
 */
export const createWebhookSubscription = async (body) => {
  try {
    const { data } = await Axios.post(RUTA, body);
    return data;
  } catch (err) {
    return falla(err);
  }
};

export const rotateWebhookSecret = async (id) => {
  try {
    const { data } = await Axios.post(`${RUTA}/${id}/rotate-secret`);
    return data;
  } catch (err) {
    return falla(err);
  }
};

/** Baja lógica: deja de entregar pero conserva el histórico de entregas. */
export const deleteWebhookSubscription = async (id) => {
  try {
    const { data } = await Axios.delete(`${RUTA}/${id}`);
    return data;
  } catch (err) {
    return falla(err);
  }
};

export const getWebhookDeliveries = async (id, { limit = 20 } = {}) => {
  try {
    const { data } = await Axios.get(`${RUTA}/${id}/deliveries`, {
      params: { limit },
    });
    return Array.isArray(data) ? data : (data?.data ?? []);
  } catch (err) {
    return falla(err);
  }
};
